import { onSelect } from '../utils/dom'

function onCustomProps(instSwiper) {
  let slider = instSwiper.el
  let quadEl = slider.closest('[data-js-quad]')
  let quadId = quadEl === null ? null : quadEl.getAttribute('data-js-quad')
  let counterEl = quadEl === null ? null : onSelect('[data-js-counter="current"]', quadEl)

  return {
    quadEl,
    quadId,
    counterEl,
  }
}

function onQuadId(nodeEle) {
  if (nodeEle === null || nodeEle === undefined) return null

  let quadNode = nodeEle.closest('[data-js-quad]')
  return quadNode === null ? null : `#${quadNode.getAttribute('data-js-quad')}`
}

function onNavigationEl(sliderId = null, sliderNode) {
  let quadBox = ''

  if (sliderId === null) {
    quadBox = onQuadId(sliderNode)
    if (quadBox === null) quadBox = ''
  } else {
    quadBox = sliderId
  }

  let nextEl = `${quadBox}.sw-arrow.sw-button-next`.trim()
  let prevEl = `${quadBox}.sw-arrow.sw-button-prev`.trim()

  return { nextEl, prevEl }
}

export { onCustomProps, onQuadId, onNavigationEl }
